import { SystemOptionEntity } from '@base/entities/BaseEntities';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BaseEntity, BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { Component, Input } from '@angular/core';
import { EnumPageDisplayModes } from '@m4u-angular/core/framework/sysenums.enum';

class State extends BaseState {
    SectionName: string;
    OptionName: string;
    Value: string;
    IsServer = true;
    IsClient = true;
    ModuleName: string = null;
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-add-system-option-dialog',
    templateUrl: './add-system-option-dialog.component.html',
    styleUrls: ['./add-system-option-dialog.component.scss']
})
export class AddSystemOptionDialogComponent extends BasePageComponent<BaseEntity, State> {

    @Input() ModulesDataSource: any[];
    @Input() IsGeneral = false;
    @Input() CustomSections: string[];

    constructor(A: ServiceBagService) {
        super(A, 'AddSystemOptionDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog);
    }

    IsValidModuleName = () => {
        if (this.ModulesDataSource.find(x => x.Value === this.State.ModuleName)) { return true; }

        return false;
    }

    OnAddOption() {
        const option = new SystemOptionEntity();
        option.OptionName = this.State.OptionName;
        option.ModuleName = this.State.ModuleName;
        option.Value = this.State.Value;
        option.IsServer = this.State.IsServer;
        option.IsClient = this.State.IsClient;
        option.SectionInfo = this.State.SectionName;

        this.CloseDialogWithSuccess(option);
    }
}
